export default __webpack_public_path__ + "static/media/nuclea.9f9f3e91.png";